/**
 * 顶层工具
 * 为了解决循环依赖而引入这个文件
 *
 * 文件之间循环依赖
 * 且引入其他文件的函数后就要立即使用的函数
 * 建议放到这里,否则可能会报错
 *
 * @filename: src/utils/topLevelUtils.ts
 * @author: Mr Prince
 * @date: 2022-06-18 20:01:32
 */
/**
 * 返回 [Object, {type}]
 */
export const toString = (() => {
    const _toString = Object.prototype.toString;
    return (obj) => _toString.call(obj);
})();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9wTGV2ZWxVdGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy90b3BMZXZlbFV0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7OztHQVdHO0FBRUg7O0dBRUc7QUFDSCxNQUFNLENBQUMsTUFBTSxRQUFRLEdBQUcsQ0FBQyxHQUFHLEVBQUU7SUFDNUIsTUFBTSxTQUFTLEdBQUcsTUFBTSxDQUFDLFNBQVMsQ0FBQyxRQUFRLENBQUM7SUFDNUMsT0FBTyxDQUFDLEdBQVksRUFBVSxFQUFFLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQztBQUN2RCxDQUFDLENBQUMsRUFBRSxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiDpobblsYLlt6XlhbdcbiAqIOS4uuS6huino+WGs+W+queOr+S+nei1luiAjOW8leWFpei/meS4quaWh+S7tlxuICpcbiAqIOaWh+S7tuS5i+mXtOW+queOr+S+nei1llxuICog5LiU5byV5YWl5YW25LuW5paH5Lu255qE5Ye95pWw5ZCO5bCx6KaB56uL5Y2z5L2/55So55qE5Ye95pWwXG4gKiDlu7rorq7mlL7liLDov5nph4ws5ZCm5YiZ5Y+v6IO95Lya5oql6ZSZXG4gKlxuICogQGZpbGVuYW1lOiBzcmMvdXRpbHMvdG9wTGV2ZWxVdGlscy50c1xuICogQGF1dGhvcjogTXIgUHJpbmNlXG4gKiBAZGF0ZTogMjAyMi0wNi0xOCAyMDowMTozMlxuICovXG5cbi8qKlxuICog6L+U5ZueIFtPYmplY3QsIHt0eXBlfV1cbiAqL1xuZXhwb3J0IGNvbnN0IHRvU3RyaW5nID0gKCgpID0+IHtcbiAgY29uc3QgX3RvU3RyaW5nID0gT2JqZWN0LnByb3RvdHlwZS50b1N0cmluZztcbiAgcmV0dXJuIChvYmo6IHVua25vd24pOiBzdHJpbmcgPT4gX3RvU3RyaW5nLmNhbGwob2JqKTtcbn0pKCk7XG4iXX0=